import React from 'react'

import FormTemplatePromo from '../../../../assets/images/promo-form-template.png'

import './FormTemplateUpsell.scss'

export const FormTemplateUpsellBody: React.FC = () => {
  return (
    <>
      <img src={FormTemplatePromo} alt='Document Fill promo' className='zocks-border-0.5 form-template-upsell-promo' />
      <div className='d-flex flex-column gap-1'>
        <h5>Skip manual document filling</h5>
        <div className='paragraph-medium'>Upload your branded PDF templates and Zocks automatically fills and exports them.</div>
      </div>
    </>
  )
}

export const FormTemplateUpsellFeatures: React.FC = () => {
  return (
    <>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Instant form documents</strong>: Create filled and branded form documents in seconds for any client.
        </div>
      </div>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>AI-powered document filling</strong>: Automatically populate PDF templates with client data.
        </div>
      </div>
      <div className='d-flex gap-2 mb-3'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Custom field mapping</strong>: Configure which form fields go into each document template.
        </div>
      </div>
    </>
  )
}
